<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Job Configuration" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="jobConfigurationPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="jobConfigurations" :fields="fieldsJobConfiguration" :busy="isDataLoading" :sort-by.sync="sortByJobConfiguration" :sort-desc.sync="sortDescJobConfiguration" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowJobConfigurationFilter = !isShowJobConfigurationFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowJobConfigurationFilter">
										<b-th></b-th>
										<b-th stacked-heading="Interface Name">
											<b-form-input id="input-interface-name-table" v-model="filterJobConfiguration.interfaceName" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Job Name">
											<b-form-input id="input-job-name-table" v-model="filterJobConfiguration.jobName" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Job Description">
											<b-form-input id="input-job-description-table" v-model="filterJobConfiguration.jobDescription" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Is Stored Procedure">
											<b-form-checkbox id="input-is-stored-procedure-table" @change="getJobConfigurations" class="float-right" v-model="filterJobConfiguration.isStoredProcedure"></b-form-checkbox>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( jobConfigurationPageSize * (currentJobConfigurationPage - 1))) }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentJobConfigurationPage"
									:total-rows="totalJobConfigurationRow"
									:per-page="jobConfigurationPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Error Message
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
::v-deep.th-message {
	color: red;
}
::v-deep.modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import JobConfiguration from '@/models/JobConfiguration/JobConfiguration';
import JobConfigurationList from '@/models/JobConfiguration/JobConfigurationList';
import JobConfigurationFilter from '@/filters/JobConfiguration/JobConfigurationFilter';

import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsJobConfiguration: [
				{"no" : { "class" : "th-number"}}, 
				{"interfaceName": { "class" : "th-interface-name", "label" : "Interface Name"}, key: 'interfaceName', sortable: true}, 
				{"jobName": { "class" : "th-job-name", "label" : "Job Name"}, key: 'jobName', sortable: true}, 
				{"jobDescription": { "class" : "th-job-description", "label" : "Job Description"}, key: 'jobDescription', sortable: true}, 
				{"isStoredProcedure": { "class" : "th-is-stored-procedure", "label" : "Is Stored Procedure"}, key: 'isStoredProcedure', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			jobConfigurations : [],
			jobConfigurationId : '',
			totalJobConfigurationRow : 0,
			isShowJobConfigurationFilter: false,
			filterJobConfiguration : null,
			currentJobConfigurationPage : 1,
			jobConfigurationPageSize: 10,
			sortByJobConfiguration: '',
			sortDescJobConfiguration: '',
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'jobconfiguration/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'jobconfiguration/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getJobConfigurations();
						data = new FormData(); _this.fileupload = null;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
						data = new FormData(); _this.fileupload = null;
					});
				}
			}
		},
		getJobConfigurations : async function() {
			let filter = {};
			Object.assign(filter, this.filterJobConfiguration);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByJobConfiguration = Array();
			if (this.sortByJobConfiguration != null) {
				this.sortingByJobConfiguration[this.sortByJobConfiguration] = this.sortDescJobConfiguration;
			}
			let currentPage = (this.currentJobConfigurationPage - 1);
			JobConfiguration.getList(this, filter, this.sortingByJobConfiguration, currentPage , this.jobConfigurationPageSize).then(result => {
				this.jobConfigurations = result.data;
				this.totalJobConfigurationRow = result.dataCount;
			}).catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'jobconfiguration/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'jobconfiguration/downloadlog', "JobConfiguration.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortByJobConfiguration : {
			handler: function() {
				this.getJobConfigurations();
			}
		},
		sortDescJobConfiguration: {
			handler: function() {
				this.getJobConfigurations();
			}
		},
		currentJobConfigurationPage: {
			handler: function() {
				this.getJobConfigurations();
			}
		},
		jobConfigurationPageSize : {
			handler: function() {
				this.getJobConfigurations();
			}
		},
		filterJobConfiguration: {
			handler: function() {
				this.getJobConfigurations();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			if (newValue) {
				this.datas = Array();
				this.isUploadSuccess = false;
			}
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterJobConfiguration = new JobConfigurationFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
